module.exports = __webpack_public_path__ + "img/foot_qr1.04c91548.png";